<template>
    <report-section
        :id="id"
        title="ECA in H60 Areas"
        class="eca-h60-area"
    >
        <div
            v-if="rollupHasData"
            class="eca-h60-area-wrapper"
        >
            <p>
                The BC Watershed Assessment Procedure Guidebook<sup>
                    <footnote-tooltip
                        :footnote-number="1"
                    />
                </sup> suggests that higher elevation portions
                of watersheds are considered critical contributors of snowmelt driven peak flows, and
                highlights the importance of treating disturbances in these areas differently from lower
                elevations in the watershed. Disturbed or regenerating tree stands are considered not
                as effective at providing interception storage or at providing a buffer for snowmelt or
                rain-on-snow processes. This sensitive area is called the H60 area and is defined as the
                highest 60% of the watershed in elevation. The chart below shows the difference in ECA between
                the entire watershed and the H60 area. Positive values indicate more ECA at higher elevations.
                For the period of 1985-2020, new detected forest disturbances are considered in ECA. For the
                period of 2021-2070, ECA is based on the recovery of previous disturbances and no new
                disturbances are taken into account.
            </p>
            <h3 class="title is-4 chart-title">
                Cumulative ECA and H60 balance in Critical Change Areas for years 1985-2070
            </h3>
            <forest-disturbance-stacked-chart
                chart-class="peak-flow-stacked-chart"
                :chart-data="reportData.rollup.data"
                :peak-flow="true"
            />
            <h3 class="title is-4 chart-title">
                ECA and H60 balance by type with Uncertainty in Critical Change Areas for years 1985-2070
            </h3>
            <forest-disturbance-line-area-chart
                chart-class="peak-flow-line-area-chart"
                :chart-data="reportData.rollup.data"
                :peak-flow="true"
            />
        </div>
        <div v-else>
            <p>There is no peak flow sensitive zone data available.</p>
        </div>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

import ForestDisturbanceLineAreaChart from '../charts/ForestDisturbanceLineAreaChart.vue';
import ForestDisturbanceStackedChart from '../charts/ForestDisturbanceStackedChart.vue';

export default {
    name: 'ECAH60AreaSection',

    components: {
        ForestDisturbanceLineAreaChart,
        ForestDisturbanceStackedChart,
    },

    mixins: [
        sectionMixin,
    ],

    computed: {
        rollupHasData() {
            return this.reportData.rollup && this.reportData.rollup.data;
        },
    },
};
</script>

<style lang="scss">
.eca-h60-area {
    .eca-h60-area-wrapper {
        .chart-title {
            margin-top: 3rem;
        }
    }
}
</style>
